import { Heart, Music2, Sparkles } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ReactionKind } from '../../cloud/api';

const REACTION_META: Record<ReactionKind, { label: string; Icon: LucideIcon }> = {
    heart: { label: 'Love', Icon: Heart },
    sparkle: { label: 'Spark', Icon: Sparkles },
    note: { label: 'Music', Icon: Music2 },
};

export function reactionLabel(kind: ReactionKind): string {
    return REACTION_META[kind].label;
}

export function ReactionIcon({
    kind,
    className = 'h-3.5 w-3.5',
}: {
    kind: ReactionKind;
    className?: string;
}) {
    const Icon = REACTION_META[kind].Icon;
    return <Icon className={className} aria-hidden strokeWidth={2.2} />;
}
